var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 8 16",
    width: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.575 15.811-3.4-3.689a.693.693 0 0 1 0-.922l.574-.6a.558.558 0 0 1 .426-.19.555.555 0 0 1 .425.19l2.4 2.6 2.4-2.6a.571.571 0 0 1 .851 0l.574.6a.693.693 0 0 1 0 .922l-3.4 3.689a.573.573 0 0 1 -.851 0zm2.85-10.411-2.425-2.606-2.4 2.606a.554.554 0 0 1 -.425.189.557.557 0 0 1 -.425-.189l-.574-.6a.692.692 0 0 1 0-.922l3.399-3.688a.571.571 0 0 1 .851 0l3.4 3.689a.693.693 0 0 1 0 .922l-.574.6a.556.556 0 0 1 -.425.189.484.484 0 0 1 -.402-.19z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/DROP_DOWN.ef525fada8eb1f53754391cc470d6d61.svg";
export { ForwardRef as ReactComponent };